import React, { PureComponent } from 'react';

import Icon from '../../common/Icon';
import MarginAuto from '../../common/MarginAuto';
import * as Icons from '../../common/icons/icons';

import { loudness } from '../../../utils/utils';

const { LOUDNESS_ICONS, getLoudnessLevel } = loudness;

class Loudness extends PureComponent<{ value?: number }> {
    _getLevel(): keyof typeof LOUDNESS_ICONS {
        const { value } = this.props;
        const safeValue = value ?? 0;
        if (!safeValue) return 'good' as keyof typeof LOUDNESS_ICONS;
        return (getLoudnessLevel(safeValue) || 'good') as keyof typeof LOUDNESS_ICONS;
    }

    render() {
        const iconName = LOUDNESS_ICONS[this._getLevel()] as keyof typeof Icons;
        return (
            <MarginAuto>
                <Icon name={iconName} />
            </MarginAuto>
        );
    }
}

export default Loudness;
